"use client";
import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <div className="fixed bottom-8 right-8 z-[9999]">
            <button
                type="button"
                onClick={scrollToTop}
                className={`
          w-12 h-12 bg-brand text-white border border-white rounded-full flex items-center justify-center shadow-2xl 
          transition-all duration-500 transform hover:bg-brand/100 hover:-translate-y-2
          ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-0 pointer-events-none"}
        `}
                aria-label="Scroll to top"
            >
                <ArrowUp size={24} strokeWidth={3} />
            </button>
        </div>
    );
}